import React from "react";
import { Navbar, Nav, NavDropdown } from "react-bootstrap";
import { NavLink } from "react-router-dom";
import {
  isSuperAdmin,
  isEngineer,
  isAccounts,
  isCustomer,
  isAdmin,
} from "../../services/authService";

const NavBar = (props) => {
  return (
    <Navbar collapseOnSelect expand="md" bg="dark" variant="dark">
      <NavLink className="navbar-brand" to="/login">
        SmartCiti Access
      </NavLink>
      <Navbar.Toggle aria-controls="responsive-navbar-nav" />
      <Navbar.Collapse id="responsive-navbar-nav">
        {props.currentUser && (
          <React.Fragment>
            <Nav>
              <NavLink className="nav-link" to="/dashboard">
                Dashboard
              </NavLink>
              {isAdmin() && (
                <React.Fragment>
                  <NavLink className="nav-link" to="/customers">
                    Customers
                  </NavLink>
                  <NavLink className="nav-link" to="/leads">
                    Leads
                  </NavLink>
                  <NavDropdown
                    title="Tariff Plans"
                    id="collasible-nav-dropdown"
                  >
                    <NavLink className="dropdown-item" to="/tariffs">
                      Tariffs
                    </NavLink>
                    <NavDropdown.Divider />
                    <NavLink className="dropdown-item" to="/bundle">
                      Bundle
                    </NavLink>
                  </NavDropdown>
                  {(isEngineer() || isSuperAdmin()) && (
                    <NavDropdown
                      title="Networking"
                      id="collasible-nav-dropdown"
                    >
                      <NavLink className="dropdown-item" to="/routers">
                        Routers
                      </NavLink>
                      <NavLink className="dropdown-item" to="/ponolts">
                        PON OLTs
                      </NavLink>
                      <NavLink className="dropdown-item" to="/ipv4pools">
                        IPv4
                      </NavLink>
                      <NavDropdown.Divider />
                      <NavLink className="dropdown-item" to="/ncc-report">
                        Quaterly NCC Report
                      </NavLink>
                    </NavDropdown>
                  )}
                </React.Fragment>
              )}
              {isCustomer() && (
                <React.Fragment>
                  <NavLink className="nav-link" to="/my-equipment">
                    My Equipment
                  </NavLink>
                </React.Fragment>
              )}
              {isAdmin() && (
                <NavDropdown title="Finance" id="collasible-nav-dropdown">
                  {(isAccounts() || isSuperAdmin()) && (
                    <NavLink className="dropdown-item" to="/expenses">
                      Expenses
                    </NavLink>
                  )}
                  {isSuperAdmin() && (
                    <NavLink className="dropdown-item" to="/financial-report">
                      Financial Report
                    </NavLink>
                  )}
                  <NavLink className="dropdown-item" to="/all-invoices">
                    Invoices
                  </NavLink>
                  <NavLink className="dropdown-item" to="/transactions">
                    Transactions
                  </NavLink>
                  <NavLink className="dropdown-item" to="/pending-renewals">
                    Pending Renewals
                  </NavLink>
                </NavDropdown>
              )}
              {isSuperAdmin() && (
                <React.Fragment>
                  <NavDropdown title="Users" id="collasible-nav-dropdown">
                    <NavLink className="dropdown-item" to="/affiliates">
                      Affiliates
                    </NavLink>
                    <NavLink className="dropdown-item" to="/admins">
                      Administrators
                    </NavLink>
                  </NavDropdown>
                  <NavLink className="nav-link" to="/config">
                    Config
                  </NavLink>
                </React.Fragment>
              )}
            </Nav>
            <Nav className="ml-auto">
              <NavLink className="nav-link" to="/my-account">
                {props.currentUser.fullName}
              </NavLink>
              <NavLink className="nav-link" to="/change-password">
                Change Password
              </NavLink>
              <NavLink className="nav-link" to="/logout">
                Logout
              </NavLink>
            </Nav>
          </React.Fragment>
        )}
      </Navbar.Collapse>
    </Navbar>
  );
};

export default NavBar;
